/**
 * O bucket da Funifier responde com CORS só no endereço regional (`<bucket>.s3.amazonaws.com`);
 * o endereço de caminho (`s3.amazonaws.com/<bucket>/…`) que a API devolve falha no `fetch`.
 */
export function urlRegionalDoS3(url: string) {
  return url.replace(/^https:\/\/s3\.amazonaws\.com\/([^/]+)\/(.+)$/, 'https://$1.s3.amazonaws.com/$2');
}

/** Baixa a imagem como arquivo. Rejeita quando a resposta não é 2xx ou a rede falha. */
export async function baixarImagem(url: string, nomeDoArquivo: string) {
  const resposta = await fetch(urlRegionalDoS3(url), { mode: 'cors' });

  if (!resposta.ok) throw new Error(`Erro ao buscar a imagem: ${resposta.status}`);

  baixarBlob(await resposta.blob(), nomeDoArquivo);
}

/** Salva o conteúdo como arquivo, pelo link de download de um objeto URL descartado logo depois. */
export function baixarBlob(conteudo: Blob, nomeDoArquivo: string) {
  const blobUrl = URL.createObjectURL(conteudo);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = nomeDoArquivo;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);
}
